import React from 'react';
import useDevices from './useDevices';

export default function useDevicesFromSite(siteId: string) {
  const { devicesBySiteId } = useDevices();
  const devices = React.useMemo(() => devicesBySiteId[siteId] ?? [], [devicesBySiteId, siteId]);
  const deviceIds = React.useMemo(() => devices.map((device) => device.id), [devices]);
  return { devices, deviceIds };
}
